import styled from 'styled-components';

export const TabledRowText = styled.div.attrs({})`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  justify-content: space-between;
`;

// Chevron do agrupamento: gira 180 graus quando o grupo esta aberto.
export const BotaoExpandir = styled.button.attrs({})`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #2670d1;
  cursor: pointer;
  transition:
    transform 0.15s ease,
    background 0.15s ease;
  transform: rotate(${(props) => (props.$aberto ? '180deg' : '0deg')});

  &:hover {
    background: rgba(38, 112, 209, 0.12);
  }

  span {
    font-size: 20px;
  }
`;
